'use strict';

import React from "react";

const 頁頭 = () => (
  <div className='app block'/>
);

export default 頁頭;



// WEBPACK FOOTER //
// ./src/網站/頁頭.jsx